"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormMatchCompetition = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var FormMatchCompetition = function (_a) {
    var video = _a.video, setVideo = _a.setVideo, channel = _a.channel, _b = _a.simple, simple = _b === void 0 ? false : _b;
    var _c = ra_fetch_1.useApi('backend').index('teams', { competition_id: channel.id }), teams = _c[0], setTeams = _c[1];
    react_1.useEffect(function () {
        ra_fetch_1.Fetcher.api('backend').index('teams', { competition_id: channel.id }).then(function (response) { return setTeams(response.data); });
    }, [channel.id]);
    return react_1.default.createElement("div", null,
        react_1.default.createElement(storybook_1.Forms.Field, { className: 'flex items-center' },
            simple && react_1.default.createElement(storybook_1.Forms.Label, null, "Kies een team"),
            react_1.default.createElement(storybook_1.Videos.FormTeamSelect, { teams: teams.data.filter(function (team) { return team.id !== Number(video.opponent_id); }), video: video, setVideo: setVideo, label: 'Kies een team' }),
            !simple && react_1.default.createElement("div", { className: 'ml-4 w-16' },
                react_1.default.createElement(storybook_1.Videos.FormTeamScore, { video: video, setVideo: setVideo }))),
        react_1.default.createElement(storybook_1.Forms.Field, { className: 'flex items-center' },
            simple && react_1.default.createElement(storybook_1.Forms.Label, null, "Kies een tegenstander"),
            react_1.default.createElement(storybook_1.Videos.FormOpponentSelect, { teams: teams.data.filter(function (team) { return team.id !== Number(video.team_id); }), video: video, setVideo: setVideo, label: 'Kies een tegenstander' }),
            !simple && react_1.default.createElement("div", { className: 'ml-4 w-16' },
                react_1.default.createElement(storybook_1.Videos.FormOpponentScore, { video: video, setVideo: setVideo }))));
};
exports.FormMatchCompetition = FormMatchCompetition;
